import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service';
import { HelperService } from '../helper.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {

  isResendEnabled: boolean = false;
  email: string;
  otp: string = '';
  message: string;

  timerText = '';
  timer = 60;
  timerRef = null;



  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private helperService: HelperService
  ) { }

  ngOnInit() {
    this.email = localStorage.getItem("email");
    this.startTimer();
  }

  resendOTP() {

    if (this.isResendEnabled) {
      this.apiService.forgetPwdResendOTP(this.email).subscribe(
        async (res: any) => {
          console.log(res);
        }, async err => {
          // console.log(err);
          this.message = err.error.meta.msg;
          return;
        })
    }
  }

  startTimer() {
    this.timerText = this.timer === 60 ? "1:00" : "0: " + this.timer;

    this.timerRef = setInterval(() => {

      this.timer -= 1;

      this.timerText = "0: " + (this.timer > 9 ? this.timer : '0' + this.timer);

      if (this.timer === 0) {
        this.isResendEnabled = true;
        clearInterval(this.timerRef);
      }

    }, 1000);
  }

  verifyOTP() {

    if (this.otp.trim() !== '' && this.otp.length === 6) {
      let otpVerifyData = {
        //token:this.helperService.studented_atob(this.helperService.getToken()),
        userID: this.helperService.studented_atob(this.helperService.getUserID()),
        userEmail: this.email, otp: this.otp
      }

      this.apiService.userAuthenticateOtp(otpVerifyData).subscribe(async (res: any) => {

        clearInterval(this.timerRef);
        this.otp = '';
        this.router.navigateByUrl(`search`);

      }, async err => {
        this.message = err.error.meta.msg;
        return;
      })



    }

  }

}


